/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum DocumentState {
    ACTIVE = 'Active',
    DISABLED = 'Disabled',
}
